import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components/ui/button';
import { AlertCircle } from 'lucide-react';
import { useTheme } from 'components/core/theme-provider';
import { useTranslation } from 'react-i18next';
import klaxLogo from 'assets/images/Vector.svg';

export function PaymentFailedPage() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { theme } = useTheme();

    const handleTryAgain = () => {
        navigate('/identity-management', {
            state: { from: '/payment-failed' }
        });
    };

    return (
        <div className="min-h-screen bg-background flex items-center justify-center p-4 w-full">
            <div className="max-w-2xl w-full text-center space-y-8">
                {/* Logo */}
                <div className="flex justify-center mb-8">
                    <img
                        src={klaxLogo}
                        alt="KLAX!"
                        className={`h-auto w-64 object-contain ${theme === 'dark' ? '' : 'drop-shadow-[0_4px_8px_rgba(0,0,0,0.6)]'}`}
                    />
                </div>

                {/* Failed Icon */}
                <div className="flex justify-center">
                    <div className="w-[334px] h-[334px] flex items-center justify-center">
                        <AlertCircle className="w-48 h-48 text-destructive" strokeWidth={1} />
                    </div>
                </div>

                {/* Content */}
                <div className="space-y-8">
                    <div className="space-y-4">
                        {/* Title */}
                        <h1 className="text-3xl font-bold leading-[48px] text-foreground font-sans">
                            {t('PAYMENT_FAILED', 'Payment failed')}
                        </h1>

                        {/* Description */}
                        <p className="text-xl font-normal leading-[30px] text-muted-foreground font-sans">
                            {t('PAYMENT_FAILED_DESCRIPTION')}
                        </p>
                    </div>

                    {/* Button */}
                    <div className="flex justify-center">
                        <Button
                            onClick={handleTryAgain}
                            className="w-[330px] h-[46px] bg-primary hover:bg-primary-600 text-primary-foreground font-semibold text-[15px] leading-[26px] rounded-md px-4 py-2.5 transition-colors"
                        >
                            {t('TRY_AGAIN', 'Try again')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

